import { type UserDto, userRoleSchema } from '@app/contracts';
import type { z } from 'zod';
import { roleLabel } from '../../../lib/role-labels';

type Role = z.infer<typeof userRoleSchema>;

interface Props {
  user: UserDto;
  currentActorRole: Role;
  currentActorId: string;
  disabled: boolean;
  onChange: (role: Role) => void;
}

const ROLE_RANK: Record<Role, number> = { super_admin: 100, admin: 50, member: 10 };

export function RoleSelect({ user, currentActorRole, currentActorId, disabled, onChange }: Props) {
  const isSelf = user.id === currentActorId;
  const cannotEditTarget = ROLE_RANK[currentActorRole] <= ROLE_RANK[user.role];
  const locked = isSelf || cannotEditTarget;

  return (
    <select
      className={`app-input !mt-0 min-w-[9.5rem] max-w-full bg-white py-[0.55rem] pr-10 ${locked ? '!cursor-not-allowed opacity-60' : ''}`}
      value={user.role}
      disabled={disabled || locked}
      onChange={(event) => onChange(event.target.value as Role)}
      title={
        isSelf
          ? 'Vous ne pouvez pas modifier votre propre rôle'
          : cannotEditTarget
            ? 'Vous ne pouvez pas modifier un rôle égal ou supérieur au vôtre'
            : undefined
      }
    >
      {userRoleSchema.options.map((option) => (
        <option
          key={option}
          value={option}
          disabled={ROLE_RANK[option] > ROLE_RANK[currentActorRole]}
        >
          {roleLabel(option)}
        </option>
      ))}
    </select>
  );
}
